import React from 'react';
import {
    EmptyWidgetBottom,
    EmptyWidgetTeam,
    EmptyWidgetTop,
    EmptyWidgetWrapper,
} from './styled';
import { ThreeDots } from '../../styled';
import Text from '../../ui/Text';

const EmptyWidget = ({ liveEventForWidget }) => {
    const hasTwoTeam =
        liveEventForWidget?.homeTeam && liveEventForWidget?.awayTeam;

    return (
        <EmptyWidgetWrapper>
            {liveEventForWidget && (
                <EmptyWidgetTop $showBg={hasTwoTeam}>
                    {liveEventForWidget && hasTwoTeam ? (
                        <>
                            <EmptyWidgetTeam>
                                <ThreeDots>
                                    {liveEventForWidget.homeTeam}
                                </ThreeDots>
                            </EmptyWidgetTeam>
                            <Text
                                size={'18'}
                                lh={'28'}
                                weight={'700'}
                                flex={'0 0 auto'}
                                color={'#000'}
                            >
                                {`${liveEventForWidget.liveScore.homeScore ||
                                    0} : ${liveEventForWidget.liveScore
                                    .awayScore || 0}`}
                            </Text>

                            <EmptyWidgetTeam $textAlign={'right'}>
                                <ThreeDots>
                                    {liveEventForWidget.awayTeam}
                                </ThreeDots>
                            </EmptyWidgetTeam>
                        </>
                    ) : (
                        <Text
                            size={'14'}
                            lh={'20'}
                            weight={'700'}
                            align={'center'}
                            padding={'0'}
                            color={'#000'}
                        >
                            {liveEventForWidget.competition}
                        </Text>
                    )}
                </EmptyWidgetTop>
            )}
            <EmptyWidgetBottom>
                <Text
                    size={'16px'}
                    lh={'24px'}
                    color={'#1E1E1E'}
                    margin={'0 0 3px'}
                    padding={'0'}
                    align={'center'}
                    bold
                >
                    Ingen matchcenter tilgængelig
                </Text>
                <Text
                    size={'14px'}
                    lh={'20px'}
                    color={'#8C94A0'}
                    margin={'0'}
                    weight={'400'}
                    padding={'0'}
                    align={'center'}
                >
                    Vi tilbyder ikke visuel dækning for dette event.
                </Text>
            </EmptyWidgetBottom>
        </EmptyWidgetWrapper>
    );
};

export default EmptyWidget;
